import { useState } from 'react';
import * as E from '../lib/engine.js';
import { Dots, ElIcon } from './PeopleBits.jsx';

// 새로운 만남: 후보 2명 중 한 명과 가까워지거나, 둘 다 지나친다. 자리가 가득 차면 멀어질 사람을 먼저 고른다
export default function MeetModal({ run, offer, onResolve }) {
  const near = E.nearPeople(run);
  const full = near.length >= E.MAX_PEOPLE;
  const [drop, setDrop] = useState(null);
  return (
    <div className="overlay">
      <div className="card modal meet">
        <div className="row" style={{ alignItems: 'center' }}>
          <span className="agechip">{run.age}세</span><span className="muted">새로운 만남</span>
          <div className="grow" /><span className="chip">곁의 사람 {near.length} / {E.MAX_PEOPLE}{full ? ' (가득 참)' : ''}</span>
        </div>
        <h2>두 사람이 먼저 말을 걸어 온다</h2>
        <div className="meetcards">
          {offer.map((q, i) => (
            <div className="mcard" key={q.id}>
              <b>{q.name}</b>
              <span className="muted">{run.age + q.ageDiff}세 · {q.role}</span>
              <span className="muted"><ElIcon el={E.personElement(q)} /> {E.personTrait(q)}형</span>
              <span className="muted">상성 <Dots n={q.compat} /></span>
              <span className="muted small">역할 힌트: {q.hint}</span>
              <button className="primary" disabled={full && !drop} onClick={() => onResolve({ offer, pick: i, dropId: full ? drop : undefined })}>가까워진다</button>
            </div>
          ))}
        </div>
        {full && (
          <div className="dropbox">
            <b>슬롯이 가득 찼어요. 가까워지려면 누구와 멀어질지 골라야 해요</b>
            <div className="chips">
              {near.map((q) => (
                <button key={q.id} className={drop === q.id ? 'on' : ''} onClick={() => setDrop(drop === q.id ? null : q.id)}>{q.name} · {q.role} ({q.closeness})</button>
              ))}
            </div>
            <span className="muted small">멀어진 사람은 소원해진 사람으로 남아요</span>
          </div>
        )}
        <div className="row">
          <button className="grow" onClick={() => onResolve({ offer, pick: null })}>둘 다 적당히 지낸다</button>
          <button className="grow" onClick={() => onResolve({ offer, pick: null, alone: true })}>혼자 일에 집중한다</button>
        </div>
      </div>
    </div>
  );
}
